import { observer }              from 'mobx-react-lite';
import projectPublicationStore   from '@/TokamapEditor/stores/projectPublicationStore';
import Button                    from '@widesk-ui/components/Button';
import currentEditorStore        from '@/TokamapEditor/stores/currentEditorStore';
import { CloudUploadOutlined }   from '@ant-design/icons';
import { LoadingOutlined }       from '@ant-design/icons';
import openPublishModal          from '@/TokamapEditor/helpers/openPublishModal';

const PublishButton = observer(() => {
	if (!currentEditorStore.isCenterDefined) return null;

	// La publication ne se termine pas avec le POST : tant que le fichier condensé du projet n'est pas
	// assemblé, rien n'est en ligne et une seconde demande n'avancerait à rien (voir
	// `projectPublicationStore`).
	const isPublishing = projectPublicationStore.isPublishing;

	// Ni `disabled` ni `loading` d'antd : tous deux donnent l'apparence désactivée, illisible sur le
	// fond sombre de l'en-tête. Le bouton garde sa couleur et ignore simplement le clic.
	return (
		<Button
			type="primary"
			icon={isPublishing ? <LoadingOutlined /> : <CloudUploadOutlined />}
			style={isPublishing ? { cursor: 'progress' } : undefined}
			onClick={() => {
				if (isPublishing) return;

				openPublishModal();
			}}
		>
			{isPublishing ? 'Publication en cours…' : 'Publier'}
		</Button>
	);
});

export default PublishButton;
